<template>
  <section>
    <div class="local-lm-filters">
      <b-field
        class="lm-label"
      >
        <b-input
          v-model.trim="orderId"
          type="text"
          :placeholder="$t('OrderFilter.labelPlaceholder')"
          class="local-lm-filters--input"
          :disabled="flag"
          @input="sendOrderId"
        />
      </b-field>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OrderNumberFilter',
  computed: {
    flag () {
      return this.$attrs.hasDisableOrderNumber
    }
  },
  data () {
    return {
      orderId: null
    }
  },
  mounted () {
    this.$eventBus.$on('cleanFilters', () => {
      this.orderId = null
    })
  },
  methods: {
    sendOrderId () {
      const flag = !!(this.orderId) || false
      this.$store.dispatch('filters/setOrderSelected', this.orderId)
      this.$eventBus.$emit('orderNumberWrite', flag)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/OrderNumberFilter.vue